"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * RecipeConverter.
 *
 * @author Adam Drda
 */


var RecipeConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(RecipeConverter, _DataObjectConverter_);

  function RecipeConverter() {
    _classCallCheck(this, RecipeConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(RecipeConverter).apply(this, arguments));
  }

  return RecipeConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.RecipeConverter = RecipeConverter;